module.exports = __webpack_public_path__ + "static/media/trowel.24edf9a4.svg";